import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { formatarDataApi } from 'src/app/util/date-format.util';
import { isFiltroIdNumerico } from 'src/app/util/consulta/wow-consulta.util';
import { ContaPagar } from './contapagar';
import { ContaPagarService } from 'src/app/service/contaPagar.service';

@Component({
  selector: 'app-conta-pagar-consulta',
  templateUrl: './conta-pagar-consulta.component.html',
  styleUrls: [
    './conta-pagar.component.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class ContaPagarConsultaComponent {

  contapagar: ContaPagar[] = [];
  ordemColunasTabela = ['id', 'favorecido', 'favorecidoDescricao', 'parcela', 'total', 'dtVencimento', 'dtPagamento', 'pagamento', 'situacao', 'excluir', 'editar'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  mensagemErros: String[] = [];
  tipoFiltro = 'ID';
  parametro = '';
  tipoFiltros: string[] = ['ID', 'Vencimento', 'Pagamento', 'Favorecido'];
  dataInicioFiltro: Date | null = null;
  dataFimFiltro: Date | null = null;
  consultaRealizada = false;
  filtroSituacao: string | null = null;
  situacoesFiltro = [
    { valor: 'A_PAGAR', label: 'A Pagar' },
    { valor: 'PAGO', label: 'Pago' },
    { valor: 'NEGOCIADO', label: 'Negociado' },
  ];

  constructor(
    private contaPagarService: ContaPagarService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
  ) { }

  novo() {
    this.router.navigate(['/contaPagar/form']);
  }

  editar(id: number) {
    this.router.navigate(['/contaPagar/form', id]);
  }

  onFiltroChange() {
    this.consultaRealizada = false;
    this.contapagar = [];
    this.totalElementos = 0;
    this.pagina = 0;
  }

  validarFiltros(): boolean {
    if (this.tipoFiltro === 'ID') {
      const termo = this.parametro?.trim();
      if (termo && !/^\d+$/.test(termo)) {
        this.snackBar.open('Informe um ID numérico válido.', 'ERRO', { duration: 2500 });
        return false;
      }
      return true;
    }
    if (this.tipoFiltro === 'Favorecido') {
      if (!this.parametro?.trim()) {
        this.snackBar.open('Informe o favorecido para consultar.', 'ERRO', { duration: 2500 });
        return false;
      }
      return true;
    }
    if (!this.dataInicioFiltro || !this.dataFimFiltro) {
      this.snackBar.open('Informe a data início e fim para consultar.', 'ERRO', { duration: 2500 });
      return false;
    }
    if (this.dataInicioFiltro.getTime() > this.dataFimFiltro.getTime()) {
      this.snackBar.open('A data início não pode ser maior que a data fim.', 'ERRO', { duration: 2500 });
      return false;
    }
    return true;
  }

  consultar(resetPagina = true) {
    if (!this.validarFiltros()) {
      return;
    }
    if (resetPagina) {
      this.pagina = 0;
    }

    const idFiltro = isFiltroIdNumerico(this.tipoFiltro, this.parametro);
    if (idFiltro != null) {
      this.contaPagarService.findClientById(idFiltro).subscribe((conta) => {
        this.contapagar = [conta];
        this.totalElementos = 1;
        this.pagina = 0;
        this.consultaRealizada = true;
        this.mensagemErros = [];
      }, err => {
        this.mensagemErros = [err.error?.message ?? 'Conta não encontrada.'];
        this.snackBar.open(String(this.mensagemErros[0]), 'ERRO', { duration: 3000 });
      });
      return;
    }

    const dataInicio = this.tipoFiltro === 'Favorecido' || this.tipoFiltro === 'ID'
      ? '01/01/2000'
      : formatarDataApi(this.dataInicioFiltro);
    const dataFim = this.tipoFiltro === 'Favorecido' || this.tipoFiltro === 'ID'
      ? '01/01/3000'
      : formatarDataApi(this.dataFimFiltro);
    const favorecido = this.tipoFiltro === 'Favorecido' ? this.parametro.trim() : '';
    const tipoConsulta = this.tipoFiltro === 'ID' ? 'Vencimento' : this.tipoFiltro;

    this.contaPagarService.findContaPagar(
      this.pagina,
      this.tamanho,
      dataInicio,
      dataFim,
      tipoConsulta,
      favorecido,
      this.filtroSituacao
    ).subscribe((response) => {
      this.contapagar = response.content ?? [];
      this.totalElementos = response.totalElements ?? 0;
      this.pagina = response.number ?? this.pagina;
      this.consultaRealizada = true;
      this.mensagemErros = [];
    }, err => {
      this.mensagemErros = [err.error?.message ?? 'Erro ao consultar contas a pagar.'];
      this.snackBar.open(String(this.mensagemErros[0]), 'ERRO', { duration: 3000 });
    });
  }

  paginar(event: PageEvent) {
    if (!this.consultaRealizada) {
      return;
    }
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar(false);
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.excluir(id);
      }
    });
  }

  private excluir(id: number) {
    this.contaPagarService.delete(id).subscribe(() => {
      this.mensagemErros = [];
      this.snackBar.open('Conta excluída com sucesso!', 'Sucesso', { duration: 2000 });
      this.consultar(false);
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + (errorResponse.error?.message ?? 'Falha ao excluir')];
    });
  }
}
